import { styled } from 'styled-components';

interface ContainerProps {
  retalvelue: boolean;
}
export const OfferSubContainer = styled.div<ContainerProps>`
  display: flex;
  padding: 0px 0 0px 80px;
  //justify-content: flex-end;
  align-items: center;
  width: 500px;
  padding: ${({ retalvelue }) => (retalvelue ? '0px 260px 0px 0px' : '0px 320px 0px 0px')};
  justify-content: flex-end;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  margin-left: 12px;
  @media screen and (max-width: 500px) {
    padding: 0px;
    width: 100%;
    margin: 0px;
  }
`;
